/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Airdefect1Inputs */



/**
* | output |
* | --- |
* | "Air fault" |
*
* @param {Ahu_History_Key_Airdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_airdefect1 = /** @type {((inputs?: Ahu_History_Key_Airdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Airdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Air fault")
	return /** @type {LocalizedString} */ ("Défaut air")
});
export { ahu_history_key_airdefect1 as "ahu_history_key_airDefect" }